export default __webpack_public_path__ + "static/media/img3.3573b84b.jpg";